//The platform the buddy is standing on. This component takes care of how the batteries are displayed

<template>
  <div class="platform platform-bg" v-hover="onHoverOverBatteries">
    <div class="batteries" :class="['batteries-' + lastRequiredBatteries]" v-hover="onHoverOverBatteries">
      <div v-for="(battery, i) in lastRequiredBatteries" :key="battery" class="battery"
           :class="['battery-' + i, getBatteryState(i), getDelay(i)]" :style="{backgroundColor: battery.color }"
           v-hover="onHoverOverBatteries"></div>
    </div>

    <div class="platform-overlay " :style="{backgroundImage: 'url(' + platformAsset + ')' }"></div>
    <HoverInfo :show="hoveringOverBatteries" :content="'Verdiende energie (punten)'" :offset-y="12"
               :offset-x="12"></HoverInfo>

  </div>
</template>

<script>
import log from "@/utils/logger";
import HoverInfo from "@/components/UI/HoverInfo.vue";

  const platformAssets = {
    '3': require('@/assets/image/platform/bb_platform_03.svg'),
    '6': require('@/assets/image/platform/bb_platform_06.svg'),
    '9': require('@/assets/image/platform/bb_platform_09.svg'),
    '12': require('@/assets/image/platform/bb_platform_12.svg'),
  }

  export default {
    name: "BuddyPlatform",
    components: {HoverInfo},
    props: {
      requiredBatteries: Number,
      obtainedBatteries: Number,
      animateNewBatteries: Boolean,
      levelUpReward: Object,
    },
    data() {
      return {
        animatingBatteries: 0,
        lastRequiredBatteries: 0,
        hoveringOverBatteries: false,
      }
    },
    computed: {
      platformAsset() {
        let asset = null;
        switch (this.lastRequiredBatteries) {
          case 0 :
            asset = platformAssets["3"];
            break;
          case 3 :
            asset = platformAssets["3"];
            break;
          case 6 :
            asset = platformAssets["6"];
            break;
          case 9 :
            asset = platformAssets["9"];
            break;
          case 12 :
            asset = platformAssets["12"];
            break;
          default:
            asset = platformAssets["3"];
            break;
        }
        return asset;
      },
    },
    watch: {
      animateNewBatteries(newVal) {
        log.info(newVal ? 'animating new batteries' : 'stopped animating new batteries');
        if (newVal === false) {
          this.lastRequiredBatteries = this.requiredBatteries;
        }
      },
      requiredBatteries(newVal, oldVal) {
        if (oldVal != null) {
          this.lastRequiredBatteries = oldVal;
        } else {
          this.lastRequiredBatteries = this.requiredBatteries;
        }
      },
    },
    mixins: [],
    methods: {
      getBatteryState(i) {
        if (this.animateNewBatteries) {
          if (this.levelUpReward.level) {
            //new level gained, blink all batteries
            return 'blinking';
          } else {
            //blink only the obtained batteries
            if (i >= (this.obtainedBatteries - this.levelUpReward.points) && i < this.obtainedBatteries) {
              return 'blinking';
            } else if (i < this.obtainedBatteries) {
              return 'show';
            } else {
              return 'hidden';
            }
          }
        } else {
          if (i < this.obtainedBatteries) {
            return 'show';
          } else {
            return 'hidden';
          }
        }
      },
      getDelay(i) {
        if (this.animateNewBatteries) {
          if (this.levelUpReward.level) {
            //new level gained, blink all batteries
            return '';
          } else {
            return 'delay-' + (i - (this.obtainedBatteries - this.levelUpReward.points));
          }
        }
      },
      onHoverOverBatteries(state) {
        this.hoveringOverBatteries = state;
      },
      triggerConfetti() {
        this.$refs.confetti.start()
      }
    },
    mounted() {

    },
    created() {

    }
  }


</script>

<style lang="scss" scoped>

  @mixin aspect-ratio($width, $height) {
    position: relative;
    &:before {
      display: block;
      content: "";
      width: 100%;
      padding-top: ($height / $width) * 100%;
    }
    > .content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  .platform {
    @include aspect-ratio(930, 200);
    width: 50%;
    //height: 20%;
    margin: 0 auto;
    bottom: -75%;
    background-position: center;
    background-size: contain;
  }

  .platform-bg {
    background-image: url("~@/assets/image/platform/bb_platform_bg.svg");
    position: absolute;
  }

  .platform-overlay {
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
    background-image: url("~@/assets/image/bb_platform_12.svg");
    z-index: 5;
    position: absolute;
    top: 0%;
    overflow: visible;
  }

  .batteries {
    width: 100%;
    height: 100%;
    //width: min(100%, );
    position: absolute !important;
    top: 0%;

    .battery {
      background-color: yellow;
      position: absolute !important;
    }
  }

  .batteries-3 {
    .battery-0 {
      width: 25%;
      transform: rotate(10deg);
      height: 37%;
      left: 7%;
      top: 46%;
    }

    .battery-1 {
      width: 25%;
      height: 37%;
      left: 37%;
      top: 53%;
    }

    .battery-2 {
      width: 22%;
      transform: rotate(-10deg);
      height: 37%;
      left: 69%;
      top: 45%;
    }
  }

  .batteries-6 {
    .battery-0 {
      width: 11.5%;
      height: 37%;
      left: 9%;
      top: 40%;
      transform: rotate(17deg) skew(-12deg);
    }

    .battery-1 {
      width: 10%;
      transform: rotate(10deg) skew(-3deg);
      height: 36%;
      left: 20%;
      top: 51%;
    }

    .battery-2 {
      width: 12%;
      transform: rotate(0deg) skew(0deg);
      height: 32%;
      left: 38%;
      top: 57%;
    }

    .battery-3 {
      width: 12%;
      transform: rotate(-1deg);
      height: 33%;
      left: 50%;
      top: 57%;
    }

    .battery-4 {
      width: 11%;
      transform: rotate(-11deg) skew(8deg);
      height: 37%;
      left: 69%;
      top: 49%;
    }

    .battery-5 {
      width: 11%;
      transform: rotate(-16deg) skew(11deg);
      height: 37%;
      left: 79%;
      top: 40%;
    }
  }

  .batteries-9 {
    .battery-0 {
      width: 8%;
      transform: rotate(24deg);
      height: 37%;
      left: 8%;
      top: 40%;
    }

    .battery-1 {
      width: 7%;
      transform: rotate(24deg);
      height: 35%;
      left: 15%;
      top: 48%;
    }

    .battery-2 {
      width: 7%;
      transform: rotate(13deg);
      height: 38%;
      left: 23%;
      top: 49%;
    }

    .battery-3 {
      width: 7%;
      transform: rotate(-1deg);
      height: 31%;
      left: 38%;
      top: 57%;
    }

    .battery-4 {
      width: 7%;
      transform: rotate(-1deg);
      height: 31%;
      left: 47%;
      top: 57%;
    }

    .battery-5 {
      width: 8%;
      transform: rotate(-1deg);
      height: 31%;
      left: 54%;
      top: 57%;
    }

    .battery-6 {
      width: 6%;
      transform: rotate(-16deg);
      height: 33%;
      left: 70%;
      top: 53%;
    }

    .battery-7 {
      width: 6%;
      transform: rotate(-23deg);
      height: 35%;
      left: 77%;
      top: 48%;
    }

    .battery-8 {
      width: 6%;
      transform: rotate(-23deg);
      height: 34%;
      left: 84%;
      top: 40%;
    }
  }

  .show {
    visibility: visible;
  }

  .hidden {
    visibility: hidden;
  }

  .blinking {
    opacity: 0;
    animation: blink 1s infinite;
  }

  @keyframes blink {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .delay-0 {
    animation-delay: 0s;
  }

  .delay-1 {
    animation-delay: 1s;
  }

  .delay-2 {
    animation-delay: 2s;
  }

  .delay-3 {
    animation-delay: 3s;
  }

  .delay-4 {
    animation-delay: 4s;
  }

  .delay-5 {
    animation-delay: 5s;
  }

  .delay-6 {
    animation-delay: 6s;
  }

  .delay-7 {
    animation-delay: 7s;
  }

  .delay-8 {
    animation-delay: 8s;
  }
</style>